import { render, staticRenderFns } from "./Tier1.vue?vue&type=template&id=5c81b10a"
import script from "./Tier1.vue?vue&type=script&lang=ts"
export * from "./Tier1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c81b10a')) {
      api.createRecord('5c81b10a', component.options)
    } else {
      api.reload('5c81b10a', component.options)
    }
    module.hot.accept("./Tier1.vue?vue&type=template&id=5c81b10a", function () {
      api.rerender('5c81b10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/upgrades/Tier1.vue"
export default component.exports